import React from 'react';
import PropTypes from 'prop-types';
import { OptimizedWithIndicatorCellRenderer } from './optimizedWithIndicatorCellRenderer.component';

export const getTooltipText = (data, colDef) => {
  const { validationData } = data;
  const isUpdated = data[colDef.field] && data[colDef.field].isUpdated;
  const hasValidationMessage = validationData && validationData.value[colDef.field];

  return [
    ...(isUpdated ? ['Updated value'] : []),
    ...(hasValidationMessage ? validationData.value[colDef.field].map(error => error.message): []),
  ].join(', ');
};

const indicator = tooltipText => (
  <div className="with-indicator" data-tip={tooltipText} />
);

const defaultCellRenderer = ({ value }) => value;

const WithIndicatorAndCustomInnerRendererCellRenderer = (customInnerRenderer = defaultCellRenderer) => (
  function WithIndicatorCellRenderer(cellData) {
    const { value: cellValue, data, colDef } = cellData;
    const tooltipText = getTooltipText(data, colDef);

    return (
      <div>
        {customInnerRenderer({ ...data, value: cellValue && cellValue })}
        {tooltipText ? indicator(tooltipText) : null}
      </div>
    );
  }
);

WithIndicatorAndCustomInnerRendererCellRenderer.propTypes = {
  cellData: PropTypes.shape({
    value: PropTypes.shape({
      value: PropTypes.string,
      isUpdated: PropTypes.bool,
    }),
    data: PropTypes.shape({
      validationData: PropTypes.shape({
        value: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
      }),
    }),
    colDef: PropTypes.shape({
      field: PropTypes.string,
    }),
  }),
};

const appendCustomRenderer = columnDefs => columnDefs.map(columnDef => {
  if (columnDef.cellRenderer) {
    return {
      ...columnDef,
      cellRenderer: WithIndicatorAndCustomInnerRendererCellRenderer(columnDef.cellRenderer),
    };
  }

  return {
    ...columnDef,
    cellRenderer: OptimizedWithIndicatorCellRenderer,
  };
});

export default appendCustomRenderer;
